import { store } from '@/api/store'

export default {
  name: 'header-without-menu',
  methods: {
    selectLang (lang) {
      let route = this.$route
      let params = route.params
      params.lang = lang
      store.set("lang", params.lang)
      this.$router.push({
        name: route.name,
        query: route.query,
        params: params
      })
      // this.show = !this.show
    }
  }
}
